import { connect } from "react-redux";

import InfoSectionUsers from "../../components/InfoSectionUsers";
import { invokeInfo } from "../AlertBoxWrapper/actions";
import { receivePrivateData } from "../App/actions";
import { changeViewport, selectUnit } from "../MapContainerWrapper/actions";

const mapStateToProps = (state, props) => ({
  id: state.modalSection[props.modalId].conf.id,
  unitTypeId: state.modalSection[props.modalId].conf.unitTypeId || null,
  user: state.user,
  token: state.initData.token,
  unitTypes: state.unitTypes.data,
  isSelectedUnit: !!state.map.selectedUnit,
  unitName: state.map.selectedUnit ? state.map.selectedUnit.name : null,
});

const mapDispatchToProps = {
  invokeInfo,
  receivePrivateData,
  selectUnit,
  changeViewport
};

const InfoSectionUsersWrapper = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfoSectionUsers);

export default InfoSectionUsersWrapper;
